export class DB{
    id: string;
    sn: string;
    name: string;
    timestamp: string;
    data: DBData[]
}

export interface DBData{
    id: string;
    type: string;
    value: any;
}